import { useCallback, useEffect, useRef, useState } from 'react';

export const useCarouselNavigation = (slideCount: number) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [announcement, setAnnouncement] = useState('');
  const activeIndexRef = useRef(0);

  const goToSlide = useCallback(
    (index: number, options?: { announce?: boolean }) => {
      if (slideCount === 0) return;

      const announce = options?.announce ?? true;
      const nextIndex = ((index % slideCount) + slideCount) % slideCount;

      activeIndexRef.current = nextIndex;

      setActiveIndex(nextIndex);

      if (announce) {
        setAnnouncement(`Slide ${nextIndex + 1} of ${slideCount}`);
      }
    },
    [slideCount],
  );

  const goNext = useCallback(
    (options?: { announce?: boolean }) =>
      goToSlide(activeIndexRef.current + 1, options),
    [goToSlide],
  );

  const goPrev = useCallback(
    (options?: { announce?: boolean }) =>
      goToSlide(activeIndexRef.current - 1, options),
    [goToSlide],
  );

  useEffect(() => {
    if (slideCount === 0) {
      activeIndexRef.current = 0;
      return;
    }

    if (activeIndex >= slideCount) {
      activeIndexRef.current = 0;
      setActiveIndex(0);
      setAnnouncement('');
    }
  }, [activeIndex, slideCount]);

  return { activeIndex, announcement, goToSlide, goNext, goPrev };
};
